import { differenceInDays } from 'date-fns';
import { matchPath, useLocation } from 'react-router';

import { VerifyPhoneNumber } from 'components/user/VerifyPhoneNumber';
import { CONFIRM_EMAIL } from 'constants/__generated__/routes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useRestrictedAccessContext } from 'contexts/restrictedAccess';
import { EmailVerificationDialog } from 'contexts/restrictedAccess/EmailVerificationDialog';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import { useSkipOneDayEmailVerificationLatency } from 'hooks/useSkipOneDayEmailVerificationLatency';

export const RestrictedAccessModals = () => {
  const { currentUser } = useCurrentUserContext();
  const { pathname } = useLocation();
  const { isMobileApp } = useIsMobileApp();

  const skipOneDayEmailVerificationLatency =
    useSkipOneDayEmailVerificationLatency();
  const { showRestrictedAccess, setShowRestrictedAccess } =
    useRestrictedAccessContext();

  const displayVerifyEmail =
    currentUser &&
    (skipOneDayEmailVerificationLatency ||
      differenceInDays(new Date(), currentUser.createdAt) > 1) &&
    !currentUser.confirmed &&
    // on mobile apps we have the notifs for reactivation
    // so we don't need to force email verification
    !isMobileApp;

  if (
    (displayVerifyEmail || showRestrictedAccess === 'email') &&
    !matchPath(CONFIRM_EMAIL, pathname)
  ) {
    return (
      <EmailVerificationDialog
        closable={!displayVerifyEmail}
        onClose={() => setShowRestrictedAccess(undefined)}
      />
    );
  }
  if (showRestrictedAccess === 'phone')
    return (
      <VerifyPhoneNumber onCancel={() => setShowRestrictedAccess(undefined)} />
    );

  return null;
};
